import * as z from 'zod/v4';
import { ENVIRONMENTS_NAMES, ALLOWED_CLONE_DIRECTIONS, validationSchema } from '../../types';

export const environmentSchema = z.object({
  name: z.enum(ENVIRONMENTS_NAMES),
  isProd: z.boolean(),
});

export const getEnvironmentsSchema = validationSchema({
  response: {
    200: z.object({
      environments: z.array(environmentSchema),
    }),
    500: z.object({
      errorMessage: z.string(),
    }),
  },
});

const cloneDirections = ALLOWED_CLONE_DIRECTIONS.map(([s, t]) => `${s}->${t}` as const);

export const envSyncLogSchema = z.object({
  id: z.string().uuid(),
  sourceEnv: z.enum(ENVIRONMENTS_NAMES),
  targetEnv: z.enum(ENVIRONMENTS_NAMES),
  triggeredBy: z.object({
    id: z.string().uuid(),
    name: z.string(),
    email: z.string(),
  }),
  startedAt: z.coerce.date(),
  completedAt: z.coerce.date().nullable(),
  status: z.string(),
  clonedCount: z.number().nullable(),
  strippedAbData: z
    .array(
      z.object({
        eventName: z.string(),
        newEventId: z.string(),
        canonicalId: z.string().optional(),
        experimentId: z.string().optional(),
        abGroupRelationIds: z.array(z.string()).optional(),
        brokenEventRefIds: z.array(z.string()).optional(),
      }),
    )
    .nullable(),
  errorMessage: z.string().nullable(),
});

export const triggerCloneSchema = validationSchema({
  body: z
    .object({
      sourceEnv: z.enum(ENVIRONMENTS_NAMES),
      targetEnv: z.enum(ENVIRONMENTS_NAMES),
    })
    .check(
      z.refine(
        data =>
          cloneDirections.includes(
            `${data.sourceEnv}->${data.targetEnv}` as (typeof cloneDirections)[number],
          ),
        {
          message: `Invalid clone direction. Allowed: ${cloneDirections.join(', ')}`,
        },
      ),
    ),
  response: {
    202: z.object({
      syncLogId: z.string().uuid(),
    }),
    409: z.object({
      errorMessage: z.string(),
    }),
    500: z.object({
      errorMessage: z.string(),
    }),
  },
});

export const getSyncLogSchema = validationSchema({
  params: z.object({
    id: z.string().uuid(),
  }),
  response: {
    200: z.object({
      syncLog: envSyncLogSchema,
    }),
    404: z.object({
      errorMessage: z.string(),
    }),
    500: z.object({
      errorMessage: z.string(),
    }),
  },
});

export const getSyncLogsSchema = validationSchema({
  querystring: z.object({
    page: z.coerce.number().optional(),
    pageSize: z.coerce.number().optional(),
  }),
  response: {
    200: z.object({
      syncLogs: z.array(envSyncLogSchema),
      total: z.number(),
      totalPages: z.number(),
    }),
    500: z.object({
      errorMessage: z.string(),
    }),
  },
});
